import React from 'react';
import { Drawer } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { ProjectHistory } from '../video-history/project-history';
import { C } from '../../constants/design-tokens';

interface HistoryDrawerProps {
  open: boolean;
  onClose: () => void;
  onEdit: (projectId: string) => void;
  onRegenerate: (projectId: string) => void;
}

export const HistoryDrawer: React.FC<HistoryDrawerProps> = ({ open, onClose, onEdit, onRegenerate }) => (
  <Drawer
    title={<span style={{ fontSize: 16, fontWeight: 1200 }}>Historial de proyectos</span>}
    open={open}
    onClose={onClose}
    closeIcon={null}
    width={720}
    styles={{
      header: { padding: '10px 16px', minHeight: 0, borderBottom: `1px solid ${C.border}` },
      body: { padding: 16 }
    }}
    extra={<CloseOutlined onClick={onClose} style={{ fontSize: 14, color: C.textSecondary, cursor: 'pointer' }} />}
  >
    <ProjectHistory
      columnsCount={1}
      onEdit={projectId => {
        onEdit(projectId);
        onClose();
      }}
      onRegenerate={projectId => {
        onRegenerate(projectId);
        onClose();
      }}
    />
  </Drawer>
);
